/* eslint-disable import/no-cycle */
import { setUserData, logoutUser } from './user.actions';
import { app } from '../../../main/api/feathers';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_OUT = 'LOGIN_OUT';
export const LOGIN_2FA_REQUIRED = 'LOGIN_2FA_REQUIRED';

export function submitLogin({ email, password }) {
  return (dispatch) =>
    app
      .authenticate({
        strategy: 'dashboard',
        email,
        password,
      })
      .then((response) => {
        const { user } = response || {};

        return app.service('users').get(user.id);
      })
      .then((user) => {
        dispatch(setUserData(user));
        dispatch({ type: LOGIN_SUCCESS });
      })
      .catch((error) => {
        if (
          error &&
          (error.message === '2FA_REQUIRED' || error.data?.twoFactorRequired)
        ) {
          return dispatch({
            type: LOGIN_2FA_REQUIRED,
            payload: { email },
          });
        }

        return dispatch({
          type: LOGIN_ERROR,
          payload: { ...error, email },
        });
      });
}

export function submitLogin2FA({ email, password, code }) {
  return (dispatch) =>
    app
      .authenticate({
        strategy: 'dashboard',
        email,
        password,
        code,
      })
      .then((response) => {
        const { user } = response || {};
        return app.service('users').get(user.id);
      })
      .then((user) => {
        dispatch(setUserData(user));
        dispatch({ type: LOGIN_SUCCESS });
      })
      .catch((error) =>
        dispatch({
          type: LOGIN_ERROR,
          payload: error,
        })
      );
}

export function loginOut() {
  return (dispatch) => {
    dispatch({ type: LOGIN_OUT });
  };
}

export function tokenValidate() {
  return (dispatch) =>
    app
      .reAuthenticate()
      .then((response) => {
        const { user } = response;
        if (user) {
          dispatch(setUserData(user));
          return dispatch({ type: LOGIN_SUCCESS });
        }
        return dispatch({ type: LOGIN_ERROR });
      })
      .catch((error) => {
        dispatch(logoutUser());
        return dispatch({ type: LOGIN_ERROR, payload: error });
      });
}
